import React from 'react';
import Layout from '../components/Layout';
import BoutiqueProductList from '../components/Boutiques/BoutiqueProductList';
import {FilterProvider} from '../components/Context/filterContext'

export default ({pageContext}) => {
    return(
      <Layout>
        <div className="sta-page-wrapper">
          <FilterProvider>
            <BoutiqueProductList boutiqueId={pageContext.id} />
          </FilterProvider>
        </div>
      </Layout>
    )
};

